import React, { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import axiosInstance from "../../Axois/Axois";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";

const DonationModal = ({ show, onClose }) => {
  const [borrowers, setBorrowers] = useState([]);
  const [selectedLoan, setSelectedLoan] = useState("");
  const token = localStorage.getItem("useToken");
  const navigate = useNavigate();

  const [donationDetails, setDonationDetails] = useState({
    borrower_id: "",
    loan: "",
  });

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    contact: "",
    total: "",
    city: "",
    country: "",
    borrower_id: "",
  });

  // ✅ Borrowers fetch when modal opens
  useEffect(() => {
    const fetchBorrowers = async () => {
      try {
        const response = await axiosInstance.get("/all/borrower");
        const allBorrowers = response?.data?.data || [];

        const filtered = allBorrowers.map((b) => ({
          id: b.id,
          name: b.name,
          loan: b.loan,
        }));

        setBorrowers(filtered);
      } catch (error) {
        console.error("Error fetching borrowers:", error);
      }
    };

    if (show) fetchBorrowers();
  }, [show]);

  // ✅ User details auto-fill
  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (user) {
      setFormData((prev) => ({
        ...prev,
        name: user.name || "",
        email: user.email || "",
        contact: user.phone || "",
      }));
    }
  }, []);

  const countries = [
    "Afghanistan",
    "Albania",
    "Algeria",
    "Andorra",
    "Angola",
    "Antigua and Barbuda",
    "Argentina",
    "Armenia",
    "Australia",
    "Austria",
    "Azerbaijan",
    "Bahamas",
    "Bahrain",
    "Bangladesh",
    "Barbados",
    "Belarus",
    "Belgium",
    "Belize",
    "Benin",
    "Bhutan",
    "Bolivia",
    "Bosnia and Herzegovina",
    "Botswana",
    "Brazil",
    "Brunei",
    "Bulgaria",
    "Burkina Faso",
    "Burundi",
    "Cabo Verde",
    "Cambodia",
    "Cameroon",
    "Canada",
    "Central African Republic",
    "Chad",
    "Chile",
    "China",
    "Colombia",
    "Comoros",
    "Congo (Congo-Brazzaville)",
    "Costa Rica",
    "Croatia",
    "Cuba",
    "Cyprus",
    "Czechia",
    "Democratic Republic of the Congo",
    "Denmark",
    "Djibouti",
    "Dominica",
    "Dominican Republic",
    "Ecuador",
    "Egypt",
    "El Salvador",
    "Equatorial Guinea",
    "Eritrea",
    "Estonia",
    "Eswatini",
    "Ethiopia",
    "Fiji",
    "Finland",
    "France",
    "Gabon",
    "Gambia",
    "Georgia",
    "Germany",
    "Ghana",
    "Greece",
    "Grenada",
    "Guatemala",
    "Guinea",
    "Guinea-Bissau",
    "Guyana",
    "Haiti",
    "Honduras",
    "Hungary",
    "Iceland",
    "India",
    "Indonesia",
    "Iran",
    "Iraq",
    "Ireland",
    "Israel",
    "Italy",
    "Ivory Coast",
    "Jamaica",
    "Japan",
    "Jordan",
    "Kazakhstan",
    "Kenya",
    "Kiribati",
    "Kuwait",
    "Kyrgyzstan",
    "Laos",
    "Latvia",
    "Lebanon",
    "Lesotho",
    "Liberia",
    "Libya",
    "Liechtenstein",
    "Lithuania",
    "Luxembourg",
    "Madagascar",
    "Malawi",
    "Malaysia",
    "Maldives",
    "Mali",
    "Malta",
    "Marshall Islands",
    "Mauritania",
    "Mauritius",
    "Mexico",
    "Micronesia",
    "Moldova",
    "Monaco",
    "Mongolia",
    "Montenegro",
    "Morocco",
    "Mozambique",
    "Myanmar (Burma)",
    "Namibia",
    "Nauru",
    "Nepal",
    "Netherlands",
    "New Zealand",
    "Nicaragua",
    "Niger",
    "Nigeria",
    "North Korea",
    "North Macedonia",
    "Norway",
    "Oman",
    "Pakistan",
    "Palau",
    "Palestine State",
    "Panama",
    "Papua New Guinea",
    "Paraguay",
    "Peru",
    "Philippines",
    "Poland",
    "Portugal",
    "Qatar",
    "Romania",
    "Russia",
    "Rwanda",
    "Saint Kitts and Nevis",
    "Saint Lucia",
    "Saint Vincent and the Grenadines",
    "Samoa",
    "San Marino",
    "Sao Tome and Principe",
    "Saudi Arabia",
    "Senegal",
    "Serbia",
    "Seychelles",
    "Sierra Leone",
    "Singapore",
    "Slovakia",
    "Slovenia",
    "Solomon Islands",
    "Somalia",
    "South Africa",
    "South Korea",
    "South Sudan",
    "Spain",
    "Sri Lanka",
    "Sudan",
    "Suriname",
    "Sweden",
    "Switzerland",
    "Syria",
    "Taiwan",
    "Tajikistan",
    "Tanzania",
    "Thailand",
    "Timor-Leste",
    "Togo",
    "Tonga",
    "Trinidad and Tobago",
    "Tunisia",
    "Turkey",
    "Turkmenistan",
    "Tuvalu",
    "Uganda",
    "Ukraine",
    "United Arab Emirates",
    "UK",
    "US",
    "Uruguay",
    "Uzbekistan",
    "Vanuatu",
    "Vatican City",
    "Venezuela",
    "Vietnam",
    "Yemen",
    "Zambia",
    "Zimbabwe",
  ];

  // ✅ Update both formData & donationDetails when borrower select hota hai
  const handleFormChange = (e) => {
    const { name, value } = e.target;

    if (name === "borrower_id") {
      const selected = borrowers.find((b) => b.id.toString() === value);
      setSelectedLoan(selected?.loan || "");

      setDonationDetails({
        borrower_id: selected?.id || "",
        loan: selected?.loan || "",
      });
    }

    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  // ✅ Payment submit
  const handlePaymentSubmit = async (e) => {
    e.preventDefault();

    const payload = new FormData();
    payload.append("name", formData.name);
    payload.append("email", formData.email);
    payload.append("contact", formData.contact);
    payload.append("city", formData.city);
    payload.append("country", formData.country);
    payload.append("payment_method", formData.payment_method || "stripe");
    payload.append("total", formData.total);

    // ✅ Borrower info from donationDetails
    payload.append("borrower_id", donationDetails.borrower_id);
    // payload.append("borrowers[0][loan]", donationDetails.loan);

    try {
      const response = await axiosInstance.post("/payment", payload, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const url = response?.data?.data;
      if (url) {
        window.location.href = url;
      } else {
        toast.success("No payment URL returned.");
      }
    } catch (error) {
      console.error("Payment error:", error);

      if (error?.response?.data?.message === "Unauthenticated.") {
        toast.error("Please login first.");
        setTimeout(() => navigate("/login"), 2000);
      } else {
        toast.error(error?.response?.data?.message || "Something went wrong.");
      }
    }
  };

  return (
    <Modal show={show} onHide={onClose} centered>
      <Form onSubmit={handlePaymentSubmit}>
        <Modal.Header
          closeButton
          style={{ backgroundColor: "#e65c00" }}
          className="text-white"
        >
          <Modal.Title className="fw-bold">
            💖 Complete Your Donation
          </Modal.Title>
        </Modal.Header>

        <Modal.Body className="bg-light text-dark px-4 py-3">
          {/* Borrower Select */}
          <Form.Group controlId="formBorrower" className="mb-3">
            <Form.Label className="fw-semibold">Select Borrower</Form.Label>
            <Form.Select
              name="borrower_id"
              required
              className="border-dark shadow-sm text-dark"
              value={formData.borrower_id}
              onChange={handleFormChange}
            >
              <option value="">-- Select Borrower --</option>
              {borrowers.length > 0 ? (
                borrowers.map((b) => (
                  <option key={b.id} value={b.id}>
                    {b.name}
                  </option>
                ))
              ) : (
                <option disabled>Loading borrowers...</option>
              )}
            </Form.Select>

            {selectedLoan !== "" && (
              <div className="mt-2 text-success fw-semibold">
                📌 Borrower's Loan Amount: ${selectedLoan}
              </div>
            )}
          </Form.Group>

          {/* Full Name */}
          <Form.Group controlId="formName" className="mb-3">
            <Form.Label className="fw-semibold">Full Name</Form.Label>
            <Form.Control
              required
              type="text"
              name="name"
              placeholder="Enter your name"
              className="border-dark shadow-sm text-dark"
              value={formData.name}
              onChange={handleFormChange}
            />
          </Form.Group>

          {/* Email */}
          <Form.Group controlId="formEmail" className="mb-3">
            <Form.Label className="fw-semibold">Email</Form.Label>
            <Form.Control
              required
              type="email"
              name="email"
              placeholder="Enter your email"
              className="border-dark shadow-sm text-dark"
              value={formData.email}
              onChange={handleFormChange}
            />
          </Form.Group>

          {/* Contact */}
          <Form.Group controlId="formContact" className="mb-3">
            <Form.Label className="fw-semibold">Contact Number</Form.Label>
            <Form.Control
              required
              type="text"
              name="contact"
              placeholder="03XX-XXXXXXX"
              className="border-dark shadow-sm text-dark"
              value={formData.contact}
              onChange={handleFormChange}
            />
          </Form.Group>

          {/* Donation Amount */}
          <Form.Group controlId="formAmount" className="mb-3">
            <Form.Label className="fw-semibold">Donation Amount</Form.Label>
            <Form.Control
              required
              type="number"
              name="total"
              placeholder="Enter amount"
              className="border-dark shadow-sm text-dark"
              value={formData.total}
              onChange={handleFormChange}
            />
          </Form.Group>

          {/* City */}
          <Form.Group controlId="formCity" className="mb-3">
            <Form.Label className="fw-semibold">City</Form.Label>
            <Form.Control
              required
              type="text"
              name="city"
              placeholder="e.g., Lahore"
              className="border-dark shadow-sm text-dark"
              value={formData.city}
              onChange={handleFormChange}
            />
          </Form.Group>

          {/* Country */}
          <Form.Group controlId="formCountry" className="mb-2">
            <Form.Label className="fw-semibold">Country</Form.Label>
            <Form.Select
              name="country"
              required
              className="border-dark shadow-sm text-dark"
              value={formData.country}
              onChange={handleFormChange}
            >
              <option value="">-- Select Country --</option>
              {countries.map((country, index) => (
                <option key={index} value={country}>
                  {country}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        </Modal.Body>

        <Modal.Footer className="bg-light px-4 py-3">
          <Button variant="outline-secondary" onClick={onClose}>
            Cancel
          </Button>
          <Button type="submit" variant="success" className="fw-bold">
            🚀 Proceed to Pay
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default DonationModal;
